import { type FC } from 'react';
import { useVerifyPayoutOrderReceipt } from '~/entities/payout';
import { ReceiptUpload, type ReceiptSubmitHandler } from './components';

interface VerifyReceiptProps {
    orderId: string;
}

export const VerifyReceipt: FC<VerifyReceiptProps> = ({ orderId }) => {
    const { mutateAsync } = useVerifyPayoutOrderReceipt();

    const handleSubmit: ReceiptSubmitHandler = async ({ base64 }) => {
        const result = await mutateAsync({
            orderId: {
                value: orderId,
            },
            receipt: base64,
        });

        return result;
    };

    return <ReceiptUpload onSubmit={handleSubmit} />;
};
